import { createContext } from 'react';

/**
 * Carries the imperative detail-view API — `{ open, replace, close, closeAll }`
 * — provided by {@link DetailViewProvider} and consumed via the
 * `useDetailViews` hook. Null when no provider is mounted (the hook throws).
 */
export const DetailViewContext = createContext(null);

export default DetailViewContext;
